import api from "./api";
import { APIS } from "../endpoints";

/**
 * Generic export function for any module
 * @param {string} moduleName - The module name (film, personality, theme, location, institution, event, posts, masterlist)
 * @param {Object|Array} moduleInputs - Optional module inputs object or array (e.g., { type: "Personality", alias: "alias_value" } or [{ type: "Personality", alias: "alias_value" }])
 * @returns {Promise<Object>} - Export result
 */
export const exportModule = async (moduleName, moduleInputs = {}) => {
    const payload = {
        module_name: moduleName,
        module_inputs: moduleInputs
    };

    try {
        const result = await api.post(`${APIS.BASE_URL}${APIS.export}`, payload);
        return result?.data;
    } catch (error) {
        console.error(`Error exporting ${moduleName}:`, error);
        throw error;
    }
};

/**
 * Get export list with pagination and search
 * @param {number} limit - Number of records per page
 * @param {number} page - Current page number
 * @param {string} searchTerm - Search term for filtering
 * @returns {Promise<Object>} - Export list result
 */
export const getExportList = async (limit, page, searchTerm) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    if (searchTerm) {
        params.append('search', searchTerm);
    }

    try {
        const result = await api.get(`${APIS.BASE_URL}${APIS.exportList}`, {
            params: params
        });
        return result?.data;
    } catch (error) {
        console.error('Error fetching export list:', error);
        throw error;
    }
};
